import {
    Container,
    Image,
    MaterialContext,
    Panel,
    Panel9Slice,
    Row,
    Column,
    Text,
    ThemeContext,
    Button,
} from '@wonderlandengine/react-ui/components';
import {Align, FlexDirection, Justify, PositionType, ReactUiBase} from '@wonderlandengine/react-ui';
import React, {useState, useEffect} from 'react';
import {Material} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {MenuButton} from './menu-button.js';
import {Ss13MaterialContext, Ss13MaterialContextValue} from './utils/ss13-material-context.js';
import {GameState, State} from '../classes/gameState.js';
import {storageSpace13} from '../globals.js';
import {Game} from '../game.js';
import {UIState} from '../models/UIModel.js';
import {GameProgress, GameProgressItems} from '../classes/GameProgress.js';

function start() {
    storageSpace13.gameState.level = 0;
    storageSpace13.gameState.state = State.Playing;
    Game.instance.uiModel.state = UIState.none;
}

function backToGame() {
    storageSpace13.gameState.state = State.Playing;
}

function restart() {
    // Restart Level
    GameProgress.instance.recordAdditive(GameProgressItems.totalRestarts, 1);
    storageSpace13.gameState.level = storageSpace13.gameState.level;
    storageSpace13.gameState.state = State.Playing;
}

function Continue() {
    storageSpace13.gameState.level = GameProgress.instance.get(GameProgressItems.lastLevel);
    storageSpace13.gameState.state = State.Playing;
}

function options() {
    // show options
    Game.instance.uiModel.state = UIState.options;
}

const App = (props: {comp: MainUI}) => {
    const [panel, setPanel] = useState('main');

    const comp = props.comp;

    const ss13Materials: Ss13MaterialContextValue = {
        buttonMaterial: comp.baseMenuButton,
        buttonHover: comp.baseMenuButtonHover,
    };

    const theme = {};

    const [isInVR, setIsInVR] = useState(storageSpace13.gameState.isInVR);
    useEffect(() => {
        const inVR = () => {
            setIsInVR(storageSpace13.gameState.isInVR);
        };
        storageSpace13.gameState.changeOnProperty('isInVR').add(inVR);
        return () => {
            storageSpace13.gameState.changeOnProperty('isInVR').remove(inVR);
        };
    }, []);

    const [titleState, setTitleState] = useState(Game.instance.uiModel.state == UIState.title);
    const [pauseState, setPauseState] = useState(Game.instance.uiModel.state == UIState.pause);

    const [playedBefore, setPlayedBefore] = useState(GameProgress.instance.get(GameProgressItems.lastLevel) != 0);

    useEffect(() => {
        const state = () => {
            setTitleState(Game.instance.uiModel.state == UIState.title);
            setPauseState(Game.instance.uiModel.state == UIState.pause);
        };
        Game.instance.uiModel.propertyChanged.add(state);

        return () => {
            Game.instance.uiModel.propertyChanged.remove(state);
        };
    }, []);

    useEffect(() => {}, []);

    return (
        <MaterialContext.Provider value={comp}>
            <Ss13MaterialContext.Provider value={ss13Materials}>
                <ThemeContext.Provider value={theme}>
                    {isInVR && titleState && (
                        <Column width="100%" height="100%" alignItems={Align.Center}>
                            <Image rounding={0} src="UI\Title.png" width={396} height={50} />

                            <MenuButton width={175} onClick={() => start()} marginBottom={4}>
                                {playedBefore ? 'Restart' : 'Start'}
                            </MenuButton>
                            {playedBefore && (
                                <MenuButton width={175} onClick={() => Continue()} marginBottom={4}>
                                    Continue
                                </MenuButton>
                            )}
                            {/* <MenuButton fontSize={16}>Options</MenuButton> */}
                        </Column>
                    )}

                    {isInVR && pauseState && (
                        <Column width="100%" height="100%" alignItems={Align.Center}>
                            <Image rounding={0} src="UI\Pause.png" width={300} height={100} />
                            <MenuButton width={196} onClick={() => backToGame()} margin={4}>
                                Continue
                            </MenuButton>
                            <MenuButton width={196} onClick={() => restart()} margin={4}>
                                Restart
                            </MenuButton>
                            <MenuButton marginTop={8} fontSize={16}>
                                Options
                            </MenuButton>
                        </Column>
                    )}
                </ThemeContext.Provider>
            </Ss13MaterialContext.Provider>
        </MaterialContext.Provider>
    );
};

/**
 * react-ui
 */
export class MainUI extends ReactUiBase {
    static TypeName = 'main-ui';
    static InheritProperties = true;

    //@ts-ignore
    @property.material({required: true})
    baseMenuButton!: Material;

    //@ts-ignore
    @property.material({required: true})
    baseMenuButtonHover!: Material;

    //@ts-ignore
    override update(dt: number) {
        super.update();
    }

    render() {
        return <App comp={this} />;
    }
}
